import React, { useContext } from 'react'
import { useSession } from 'components/auth/Session'
import { TenantFlag as GQLTenantFlag } from 'generated/types'

export interface Features {
  isFreemium?: boolean
  isLegacy?: boolean
}

interface TenantFlag extends Omit<GQLTenantFlag, '__typename'> {}

const FeaturesContext = React.createContext<Features>({})

const hasFlag = (flags: TenantFlag[], key: string, value: string) => {
  return Boolean(flags.find((flag) => {
    return flag.key === key && flag.value === value
  }))
}

export const FeaturesProvider: React.FC = (props) => {
  const session = useSession()

  const flags: TenantFlag[] = session.user?.tenant?.flags || []

  const features: Features = {
    isFreemium: hasFlag(flags, 'freemium', 'true'),
    isLegacy: hasFlag(flags, 'legacy', 'true'),
  }

  return (
    <FeaturesContext.Provider value={features}>
      {props.children}
    </FeaturesContext.Provider>
  )
}

export const useFeatures = () => useContext(FeaturesContext)
